export enum ActionNames {
  HISTORY_NAV_TO = "HistoryNavTo",
  HISTORY_RESET  = "HistoryReset",
  SHOW_TOAST     = "ShowToast",
  SHOW_LOADER    = "ShowLoader",
  HIDE_LOADER    = "HideLoader"
}